import axios from "axios";
import { useQuery } from "react-query";
import {configUrl} from "config.js";
import { LoginContext } from "contexts/LoginContext";
import { useContext } from "react";


export default function useGetAllUserCountByState() {
  const { config, providerId } = useContext(LoginContext);

  return useQuery("userCountByState", async () => {
    let response = await axios.get(
      `${configUrl.AssessmentServer}/api/Analytics/dashboard/GetUserCountByState/${providerId}`
    );
    let lables =response.data.lable['$values'];
    let values =response.data.values['$values']
    console.log({
      lables,values
    })
    return{
      lables,values
    };
  });
}
